"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Action() {
  const shouldReduceMotion = useReducedMotion();
  const animationProps = shouldReduceMotion ? {
    initial: {
      opacity: 1,
      y: 0
    },
    whileInView: {
      opacity: 1,
      y: 0
    }
  } : {
    initial: {
      opacity: 0,
      y: 12
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true,
      amount: 0.3
    },
    transition: {
      duration: 0.5,
      ease: [0.16, 1, 0.3, 1]
    }
  };
  return <section id="llamado-a-la-acción" data-nav="dark" className="dark relative w-full overflow-hidden bg-background text-foreground py-20 lg:py-28">
      {/* Top 1.5px satin gold hairline */}
      <div className="absolute top-0 inset-x-0 h-[1.5px] bg-ring/40" />

      <div className="relative mx-auto max-w-5xl px-6 md:px-10 lg:px-16 text-center">
        {/* Subtle Institutional Badge */}
        <motion.div {...animationProps} className="inline-flex items-center gap-2 px-3 py-1 mb-6 rounded-xs border border-ring/40 bg-ring/10 text-ring text-xs font-serif uppercase tracking-[0.15em] font-semibold">
          <ShieldCheck className="size-3.5 text-ring" />
          <span>Gobierno · Empresa · Legal</span>
        </motion.div>

        {/* Central Gold Hairline Accent */}
        <div className="mx-auto mb-6 h-[1.5px] w-12 bg-ring" />

        {/* Headline */}
        <motion.h2 {...animationProps} className="text-2xl sm:text-3xl lg:text-4xl font-serif font-bold uppercase tracking-[0.06em] text-foreground max-w-4xl mx-auto leading-tight">
          Fortalezca el cumplimiento normativo y la disciplina fiscal de su administración
        </motion.h2>

        {/* Supporting Line */}
        <motion.p {...animationProps} className="mt-6 text-base sm:text-lg text-muted-foreground font-sans max-w-2xl mx-auto leading-relaxed">
          Acompañamos a tesorerías municipales, dependencias estatales y organismos descentralizados con rigor técnico, armonización CONAC y respaldo directivo continuo.
        </motion.p>

        {/* CTA Button Group */}
        <motion.div {...animationProps} className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="rounded-xs bg-foreground text-background border border-ring font-serif uppercase tracking-[0.08em] font-semibold text-xs sm:text-sm px-8 py-3.5 hover:bg-ring hover:text-foreground transition-colors">
            <Link to="/ContactPage" className="inline-flex items-center gap-2">
              <span>Solicitar asesoría gubernamental</span>
              <ArrowRight className="size-4" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="rounded-xs border-ring/50 text-ring bg-transparent font-serif uppercase tracking-[0.08em] font-semibold text-xs sm:text-sm px-7 py-3.5 hover:bg-ring/10 hover:text-ring hover:border-ring transition-colors">
            <Link to="/OnlineConsultingPage">
              Consultoría en línea
            </Link>
          </Button>
        </motion.div>

        {/* Institutional Credibility Note */}
        <p className="mt-8 text-xs text-muted-foreground font-sans tracking-wide">
          Atención coordinada por directores especializados en contabilidad gubernamental y fiscalización pública.
        </p>
      </div>

      {/* Bottom 1.5px satin gold hairline */}
      <div className="absolute bottom-0 inset-x-0 h-[1.5px] bg-ring/40" />
    </section>;
}